export interface GroupsBackroomState {
  folder?: GroupNotesFolderType;
}

export enum GroupNotesFolderType {
  ARCHIVED = 'archived',
  STARRED = 'starred',
  INBOX = 'inbox',
}
